import React, { FC, useEffect, useState } from "react";
import styles from "./TableItem.module.sass";
import cn from "classnames";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { IObject } from "toolkit/steps/stepSeven/stepSeven.types";
import {
	addToAttachmentList,
	changeChooseAll,
	removeFromAttachmentList,
} from "toolkit/steps/stepSeven/stepSeven.slice";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { ReactComponent as TickIcon } from "images/TickIcon.svg";
import { ViewingInfo } from "pages/StepPages/StepSeven/ViewingInfo/ViewingInfo";
import { AssigningNumber } from "pages/StepPages/StepSeven/AssigningNumber/AssigningNumber";
import ConfirmNavigate from "components/ConfirmNavigate";
import { useLocation, useParams } from "react-router-dom";
import { Address } from "./Address/Address";
import { getObjectLocations } from "toolkit/steps/stepSeven/stepSeven.thunks";

interface TableItemProps {
	object: IObject;
	sequenceNumber: number;
	repeatable?: boolean;
	address?: boolean;
}

export const TableItem: FC<TableItemProps> = ({ object, sequenceNumber, repeatable }) => {
	const { organizationId } = useParams();
	const { attachmentMode, attachmentList, allChecked, allCheckedGlobal, excludedObjects } = useAppSelector(
		(state) => state.stepSeven,
	);
	const location = useLocation();

	const [checkbox, setCheckbox] = useState<boolean>(false);
	const [shownLocations, setShownLocations] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const [confirmAction, setConfirmAction] = useState<boolean>(false);
	const [modalWindow, setModalWindow] = useState<boolean>(false);

	useEffect(() => {
		if (allChecked && attachmentList.includes(object.id)) setCheckbox(true);
		else if (!allChecked && allChecked !== null) setCheckbox(false);
		//eslint-disable-next-line
	}, [allChecked, attachmentList]);

	useEffect(() => {
		if (attachmentList.includes(object.id) || (allCheckedGlobal && !excludedObjects.includes(object.id)))
			setCheckbox(true);
		//eslint-disable-next-line
	}, []);

	// 1042. что это? на шестой шаг тоже надо добавить?
	useEffect(() => {
		if (location.state?.outline === object.id) {
			clickHandler();
		}
		//eslint-disable-next-line
	}, [location.state]);

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(changeChooseAll(null));
		if (e.target.checked) dispatch(addToAttachmentList(object.id));
		else dispatch(removeFromAttachmentList(object.id));
		setCheckbox(e.target.checked);
	};

	const confirmClick = () => {
		setModalWindow(true);
		setConfirmAction(false);
	};

	const showLocationsHandler = () => {
		if (object.hasMoreLocations && !object.locations.length) {
			dispatch(getObjectLocations({ orgId: Number(organizationId), object: object }));
		}
		setShownLocations((prev) => !prev);
	};

	const clickHandler = () => {
		if (attachmentMode) return;
		if (repeatable) setConfirmAction(true);
		else {
			setModalWindow(true);
			setConfirmAction(false);
		}
	};

	return (
		<>
			{modalWindow && (
				<ModalWindow
					close={() => setModalWindow(false)}
					scroll={Boolean(object.fstekCategory && object.fstekId && object.fstekLetter?.key)}>
					{object.fstekCategory && object.fstekId && object.fstekLetter?.key ? (
						<ViewingInfo close={() => setModalWindow(false)} object={object} />
					) : (
						<AssigningNumber close={() => setModalWindow(false)} object={object} address={null} />
					)}
				</ModalWindow>
			)}
			<ConfirmNavigate toggle={confirmAction} close={() => setConfirmAction(false)} clickHandler={confirmClick} />
			<tr onClick={clickHandler} className={styles.row}>
				<td className={styles.item}>
					<div className={styles["item-wrp"]}>
						{attachmentMode && (
							<label onClick={(e) => e.stopPropagation()} className={styles.label} htmlFor={`object-${object.id}`}>
								<input
									id={`object-${object.id}`}
									checked={checkbox}
									onChange={changeHandler}
									type="checkbox"
									className={styles.checkbox}
								/>
							</label>
						)}
						<div
							className={cn(
								styles.sign,
								!object.fstekLetter && styles["sign-noLetter"],
								object.fstekId ? styles["sign-assigned"] : styles["sign-unassigned"],
								repeatable && styles["sign-repeatable"],
							)}></div>
						{object.hasMoreLocations ? (
							<>
								<input
									onClick={(e) => e.stopPropagation()}
									id={`tick-${object.id}`}
									type="checkbox"
									className={styles["input-tick"]}
									onChange={showLocationsHandler}
								/>
								<label
									onClick={(e) => e.stopPropagation()}
									className={styles["label-tick"]}
									htmlFor={`tick-${object.id}`}>
									<TickIcon />
								</label>
							</>
						) : (
							""
						)}
						{sequenceNumber + 1}
					</div>
				</td>
				<td className={styles.item}>{object.code || "—"}</td>
				<td className={styles.item}>{object.name || "—"}</td>
				<td className={styles.item}>{object.type || "—"}</td>
				<td className={styles.item}>{object.activity || "—"}</td>
				<td className={styles.item}>{object.fstekId || "—"}</td>
			</tr>
			{shownLocations &&
				!attachmentMode &&
				object.locations.map((address, i: number) => (
					<Address
						key={address.id}
						address={address}
						parent={object}
						objectNumber={sequenceNumber}
						sequenceNumber={i}
					/>
				))}
		</>
	);
};
